import { writable } from 'svelte/store';

const KEY = 't_asset_metadata_'

export const defaultValueMetadata = {
  "id":"",
  "type":"",
  "url":"",
  "defaultFileName":"",
  "originalImageSize":[0, 0],
  "stackable":false,
  "overrideX": 0,
  "overrideY": 0,
  "dimensions":[
     1,
     1,
     1
  ]
}

const persistValueMetadata = localStorage.getItem(KEY)

export const jsonData = writable(persistValueMetadata || JSON.stringify(defaultValueMetadata));
export const state = writable({});